import { format, isValid } from "date-fns";

export const generateDate = (dateInMilliseconds: number) => {
  const date = new Date(dateInMilliseconds);
  return isValid(date) ? format(date, "dd.MM.yyyy") : "unknown";
};

export const normalizeWhat3Words = (value: string) =>
  value.trim().replace(/\s+/g, ".");

export const getWhat3WordsHref = (value: string) =>
  `https://what3words.com/${normalizeWhat3Words(value)}`;
